import { requestGet, requestPost } from '@/common/request';

export default {
  // 会场运营 - 会场活动创建
  async roomCreateActivity(params) {
    return await requestPost('/room/createActivity', params);
  },

  // 会场运营 - 会场活动编辑
  async roomUpdateActivity(params) {
    return await requestPost('/room/updateActivity', params);
  },

  // 会场运营 - 会场活动检索
  async roomQueryActivities(params) {
    return await requestGet('/room/queryActivities', params);
  },

  // 会场运营 - 会场管理员查询
  async roomMemberQueryRoomMembers(params) {
    return await requestGet('/roomMember/queryRoomMembers', params);
  },

  // 会场运营 - 添加会场管理员成员
  async roomMemberAddMembers(params) {
    return await requestGet('/roomMember/addMembers', params);
  },

  // 会场运营 - 转移管理组组长
  async roomMemberTransferLeader(params) {
    return await requestGet('/roomMember/transferLeader', params);
  },

  // 会场运营 - 移除管理组成员
  async roomMemberRemoveMember(params) {
    return await requestGet('/roomMember/removeMember', params);
  },

  // 会场运营 - 查询当前登录用户的有效通天塔项目
  async roomValidTowerList(params) {
    return await requestGet('/room/validTowerList', params);
  },

  // 会场运营 - 关联通天塔项目
  async roomAssociateTower(params) {
    return await requestPost('/room/associateTower', params);
  },

  // 会场运营 - 查询通天塔项目关联的会场活动
  async roomQueryActivityByTowerId(params) {
    return await requestGet('/room/queryActivityByTowerId', params);
  },

  // 会场运营 - 查询会场活动审核数
  async roomQueryAuditNumbers(params) {
    return await requestGet('/room/queryAuditNumbers', params);
  },

  // 会场运营 - 根据会场活动 id 查询详情
  async roomGetDetailByRoomId(params) {
    return await requestGet('/room/getDetailByRoomId', params);
  },

  // 会场运营 - 查询会场关联的提报活动与通天塔活动
  async roomActivityAssociation(params) {
    return await requestGet('/room/activityAssociation', params);
  },
  // 主推品类接口
  async cateList(params) {
    return await requestGet('/cate/list', params);
  },

  async activityPlanGet(query) {
    return await requestGet('/activityPlan/getByVer', query);
  },

  async actRoomRoomHeader(query) {
    return await requestGet('/actRoom/roomHeader', query);
  },
  async actRoomFloorList(query) {
    return await requestGet('/actRoom/floorList', query);
  },
  async actRoomAddPage(query) {
    return await requestPost('/actRoom/addPage', query);
  },

  // 会场运营 - 根据会场活动 id 查通天塔信息
  async roomTowerHeader(query) {
    return await requestGet('/room/towerHeader', query);
  },

  // 会场运营 - 增加通天塔页面
  async roomAddTowerPage(query) {
    return await requestGet('/room/addTowerPage', query);
  },

  // 会场运营 - 判断用户是否为管理组成员
  async roomMemberIsMember(query) {
    return await requestGet('/roomMember/isMember', query);
  },

  async roomGetAuditNumber(query) {
    return await requestGet('/room/getAuditNumber', query);
  },

  // 文件上传
  async fileUpload(query) {
    return await requestPost('/oss/file/upload?module=7', query);
  },
  // 日常活动 - 活动名称校验
  async roomNameValidate(query) {
    return await requestGet('/room/roomNameValidate', query);
  },
  async roomPoolReportFeedback(query) {
    return await requestPost('/roomPool/reportFeedback', query);
  },
};
